export default function Configure($stateProvider) {
    $stateProvider.state('refsaisiesecu', {
        parent: 'common',
        url: '/refsaisiesecu',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.SECURITE_PERSONNEL" | translate }}'
        }
    });

    $stateProvider.state('refsaisiesecu.list', {
        url: '/list',
        template: '<trames-saisies></trames-saisies>',
        rights: { domain: 'refsaisiesecu', right: 'read' },
        ncyBreadcrumb: {
            parent: 'refsaisiesecu',
            label: '{{ "TRAMES.BREADCRUMBS.TRAMES_LIST" | translate}}'
        },
        navigation: {
            menu: 'securite_personnel_donnees',
            translate: 'TRAMES.BREADCRUMBS.TRAMES_LIST',
            order: 6
        },
        search: 'TRAMES.BREADCRUMBS.TRAMES_LIST'
    });

    $stateProvider.state('refsaisiesecu.list.detail', {
        url: '/{id}',
        template: '<trame-saisie-detail></trame-saisie-detail>',
        rights: { domain: 'refsaisiesecu', right: 'read' },
        ncyBreadcrumb: {
            parent: 'refsaisiesecu.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('refsaisiesecu.new', {
        url: '/new',
        template: '<trame-saisie-form></trame-saisie-form>',
        rights: { domain: 'refsaisiesecu', right: 'create' },
        ncyBreadcrumb: {
            parent: 'refsaisiesecu.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_NEW" | translate}}'
        },
        search: 'TRAMES.BREADCRUMBS.TRAME_NEW'
    });

    $stateProvider.state('refsaisiesecu.edit', {
        url: '/{id}/edit',
        template: '<trame-saisie-form></trame-saisie-form>',
        rights: { domain: 'refsaisiesecu', right: 'update' },
        ncyBreadcrumb: {
            parent: 'refsaisiesecu.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_EDIT" | translate }}'
        }
    });

    $stateProvider.state('refsaisiesecu.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: { parentState: 'refsaisiesecu.new' },
        ncyBreadcrumb: {
            parent: 'refsaisiesecu.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });

    $stateProvider.state('refsaisiesecu.duplicate', {
        url: '/{id}/duplicate',
        template: '<trame-saisie-form></trame-saisie-form>',
        rights: { domain: 'refsaisiesecu', right: 'create' },
        ncyBreadcrumb: {
            parent: 'refsaisiesecu.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_NEW" | translate}}'
        },
        params: {
            duplicate: true
        }
    });
}

Configure.$inject = ['$stateProvider'];
